import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMytaverse } from '@providers/MytaverseProvider';
import ParticipantsService from '@services/ParticipantsService';
import ProfileCompletionModalView from './ProfileCompletionModalView';
import { useProfileCompletionModalState } from './context';
import { IUser } from '@interfaces/user';
import ROUTES from '@constants/routes';

const ProfileCompletionModal = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user, setUser } = useMytaverse();
  const { open, setOpen } = useProfileCompletionModalState();
  const [name, setName] = useState('');
  const [gender, setGender] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const isProfileIncomplete =
      user &&
      (!user.name?.trim() || !user.gender || !['male', 'female'].includes(user.gender));

    if (isProfileIncomplete) {
      setName(user.name?.trim() || '');
      setGender(user.gender || '');
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [user, setOpen]);

  const handleSubmit = useCallback(async () => {
    if (!isSubmitting && name.trim() && (gender === 'male' || gender === 'female')) {
      try {
        setIsSubmitting(true);
        await ParticipantsService.updateCurrentParticipantProfile({
          name: name.trim(),
          gender,
        });

        setUser((prevState: IUser) => ({
          ...prevState,
          name: name.trim(),
          gender,
        }));

        setOpen(false);

        if (
          pathname === ROUTES.HOME_PAGE ||
          pathname.includes(ROUTES.LOGIN)
        ) {
          navigate(ROUTES.SELECT_EVENT);
        }
      } catch (e) {
        console.error('Error updating profile:', e);
      } finally {
        setIsSubmitting(false);
      }
    }
  }, [name, gender, isSubmitting, setUser, setOpen, pathname, navigate]);

  if (!open) {
    return null;
  }

  return (
    <ProfileCompletionModalView
      open={open}
      name={name}
      gender={gender}
      onSubmit={handleSubmit}
      onNameChange={setName}
      onGenderChange={setGender}
      isSubmitting={isSubmitting}
    />
  );
};

export default ProfileCompletionModal;
